import React from 'react';

import EmailAcknowledgmentConfiguration from '~/components/SystemConfiguration/EmailConfiguration/EmailAcknowledgmentConfiguration';
import type { EmailConfigurationsResponse } from '~/components/SystemConfiguration/EmailConfiguration/emailConfigurationTypes';
import EmailNotificationSuppressionConfiguration from '~/components/SystemConfiguration/EmailConfiguration/EmailNotificationSuppressionConfiguration';
import EmailSignatureAndTitleConfiguration from '~/components/SystemConfiguration/EmailConfiguration/EmailSignatureAndTitleConfiguration';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import useDataFetcher from '~/components/useDataFetcher';

import EmailGeneralConfiguration from './EmailGeneralConfiguration';

const BASE_PATH = '/api/v1/email_configuration/organizations';

const EmailConfiguration: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { organization } = useSysconfig();

  const {
    data: emailConfigurationTableData,
    reloadData,
    isLoading: isLoadingEmailConfigurationTableData,
    isError: isErrorEmailConfigurationTableData,
  } = useDataFetcher<EmailConfigurationsResponse>(`${BASE_PATH}/${organization.id}`);

  const isAcknowledgmentEnabled = !!emailConfigurationTableData?.email_acknowledgment_configuration?.is_enabled;

  return (
    <div className="bg-slate-100 p-4">
      <EmailSignatureAndTitleConfiguration
        isLoadingEmailConfigurationTableData={isLoadingEmailConfigurationTableData}
        isErrorEmailConfigurationTableData={isErrorEmailConfigurationTableData}
        emailSignatureAndTitleTableData={emailConfigurationTableData?.email_signature_and_title_configurations}
        reloadData={reloadData}
      />

      <EmailAcknowledgmentConfiguration
        isLoading={isLoadingEmailConfigurationTableData}
        isError={isErrorEmailConfigurationTableData}
        emailAcknowledgmentConfiguration={emailConfigurationTableData?.email_acknowledgment_configuration}
        isAcknowledgmentEnabled={isAcknowledgmentEnabled}
        reloadData={reloadData}
      />

      <EmailNotificationSuppressionConfiguration
        emailNotificationSuppressionRules={emailConfigurationTableData?.email_notification_suppression_rules || []}
        isLoading={isLoadingEmailConfigurationTableData}
        isError={isErrorEmailConfigurationTableData}
        reloadData={reloadData}
      />

      <EmailGeneralConfiguration
        emailGeneralConfiguration={emailConfigurationTableData?.email_general_configuration}
        isLoading={isLoadingEmailConfigurationTableData}
        isError={isErrorEmailConfigurationTableData}
        reloadData={reloadData}
      />
    </div>
  );
};

export default EmailConfiguration;
